<template>
    <div class="el-input el-input--mini">
        <label>
            <input :id="inputId" class="el-input__inner" :value="value" @input="handleInput">
        </label>
    </div>
</template>
<script>
/*
    Restricts input for the given textbox to the given inputFilter.
    https://stackoverflow.com/questions/469357/html-text-input-allow-only-numeric-input
    Some input filters you might want to use:
    Integer values (both positive and negative):
    /^-?\d*$/.test(value)
    Integer values (positive only):
    /^\d*$/.test(value)
    Integer values (positive and up to a particular limit):
    /^\d*$/.test(value) && (value === "" || parseInt(value) <= 500)
    Floating point values (allowing both . and , as decimal separator):
    /^-?\d*[.,]?\d*$/.test(value)
    Currency values (i.e. at most two decimal places):
    /^-?\d*[.,]?\d{0,2}$/.test(value)
    Hexadecimal values:
    /^[0-9a-f]*$/i.test(value)
*/
//
function setInputFilter(textBox, inputFilter) {
    if (!textBox) {
        return;
    }
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function(event) {
        textBox.addEventListener(event, function() {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (Object.prototype.hasOwnProperty.call(this, 'oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

export default {
    name: 'InputDigits',
    props: {
        value: {
            type: [Number, String],
            default: 0
        }
    },
    data() {
        return {
            inputId: Math.random().toString(36).substr(2, 9)
        };
    },
    mounted() {
        this.setInputFilter(document.getElementById(this.inputId), function(value) {
            return /^-?\d*$/.test(value);
        });
    },
    methods: {
        setInputFilter,
        handleInput(event) {
            this.$nextTick(function() {
                this.$emit('input', event.target.value);
            });
        }
    }
};
</script>
